import React, { useEffect, useRef, useState } from 'react';
import { getImages } from '../const'

const serviceOption = [
    {
        image: 'slide-1.png',
        title: 'View Inventory',
    },
    {
        image: 'slide-2.png',
        title: 'Sell or Trade',
    },
    {
        image: 'slide-3.png',
        title: 'Service Center',
    },
    {
        image: 'slide-4.png',
        title: 'Specials',
    },
]
const Box = ({ index, isInCenter, item }) => {
    return (
        <a href="#" className={`service-box d-inline-block ${isInCenter ? 'selected' : ''}`}>
            <img src={getImages(item.image)} alt='' />
            <div className='service-pos'><span>{item.title}</span></div>
        </a>
    );
  };
const HomeServices = () => {
    const boxesRef = useRef([]);
    const [centeredBoxIndex, setCenteredBoxIndex] = useState(null);
  
    const checkIfInCenter = () => {
      const windowHeight = window.innerHeight;
  
      boxesRef.current.forEach((box, index) => {
        if (box) {
          const boxRect = box.getBoundingClientRect();
          const boxCenter = boxRect.top + boxRect.height / 2;
  
          // Check if the box's center is in the viewport's center
          if (boxCenter > windowHeight / 2 - 50 && boxCenter < windowHeight / 2 + 50) {
            setCenteredBoxIndex(index);
          }
        }
      });
    };
  
    useEffect(() => {
      // Call on scroll
      window.addEventListener('scroll', checkIfInCenter);
  
      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener('scroll', checkIfInCenter);
      };
    }, []);
  return (
    <>
        <section className='services-wrap'>
            <div className='container'>
                <div className='row mlr-40'>
                    {serviceOption.map((item, index) => (
                        <div
                        key={index}
                        ref={(el) => (boxesRef.current[index] = el)} 
                            className='col-md-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s"
                        >
                            <Box index={index + 1} isInCenter={centeredBoxIndex === index} item={item} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
        {/* <section className='services-wrap'>
            <div className='container'>
                <div className='row mlr-40'>
                    <div ref={box1Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 0 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="0.5s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-1.png')} alt='' />
                            <div className='service-pos'><span>View Inventory</span></div>
                        </a>
                    </div>
                    <div ref={box2Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 1 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="1s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-2.png')} alt='' />
                            <div className='service-pos'><span>Sell or Trade</span></div>
                        </a>
                    </div>
                    <div ref={box3Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 2 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="1.5s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-3.png')} alt='' />
                            <div className='service-pos'><span>Service Center</span></div>
                        </a>
                    </div>
                    <div ref={box4Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 3 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="2s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-4.png')} alt='' />
                            <div className='service-pos'><span>Specials</span></div>
                        </a>
                    </div>
                </div>
            </div>
        </section> */}
    </>
  )
}

export default HomeServices